import { useState } from "react"

import type { Role } from "@/graphql/codegen/graphql"
import type { SystemAdminDialog } from "@/screens/SystemAdmin/types"

interface UseSystemAdminModalReturn {
  dialogOpen: SystemAdminDialog | null
  setDialogOpen: (dialog: SystemAdminDialog | null) => void
  selectedRole: Role | null
  setSelectedRole: (selectedRole: Role | null) => void
}

export const useSystemAdminDialog = (): UseSystemAdminModalReturn => {
  const [dialogOpen, setDialogOpen] = useState<SystemAdminDialog | null>(null)
  const [selectedRole, setSelectedRole] = useState<Role | null>(null)

  return {
    dialogOpen,
    selectedRole,
    setDialogOpen,
    setSelectedRole,
  }
}
